<template>
    <div>
        <el-dialog title="收款信息" append-to-body :visible.sync="billPayBoxFlag">
            <div style="display:flex;text-align:center;padding-bottom:1rem;">
                <div style="flex:1">房间:{{communityName}}</div>
                <div style="flex:1">客户：{{payManName}}</div>
                <div style="flex:1">费用合计：{{totalCalAmount}}元</div>
            </div>
            <div style="padding:1rem 0;">
                <el-table
                v-if="showBillPayTableFlag"
                ref="billPayTable"
                border
                :data="billPayData"
                style="width: 100%">
                    <el-table-column
                        prop="subjectName"
                        label="收费科目"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="couponId"
                        label="优惠政策"
                        width="180">
                <template slot-scope="scope">
                    <!-- <span style="margin-left: 10px">{{ handleShowPrice(scope.row) }}</span> -->
                    
                    <el-select 
                        clearable
                        v-model="scope.row.couponId"
                        @change="couponNameChange(scope,scope.row.couponId)"
                    >
                        <el-option
                            v-for="item in scope.row.couponName"
                            :key="item"
                            :value="item.id"
                            :label="item.name"
                        >
                        </el-option>
                    </el-select>
                </template>
                    </el-table-column>
                    <el-table-column
                        prop="billcycleNo"
                        label="缴费月份"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="billAmount"
                        label="应收金额"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="discount"
                        label="减免金额"
                        >
                        <template slot-scope="scope">
                            <span>{{ scope.row.discount }}</span>
                                <!-- <el-input v-model="scope.row.discount"></el-input> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <avue-form
                ref="billPayForm"
                v-if="billPayBoxFlag"
                :option="billPayFormOption"
                v-model="billPayForm"
            >
                
                <template slot="coupon">
                    <el-input type="text" v-model="billPayForm.coupon" maxlength="20" placeholder="请输入优惠券码"></el-input>
                </template>
                <template slot="authCode">
                    <!-- v-if="showAuthCodeFlag" -->
                    <el-input type="password" ref="authCodeInput" v-model="billPayForm.authCode" @blur="blurHandler" @input="inputHandler" @focus="focusHandler" maxlength="18" placeholder="请输入优惠券码"></el-input>
                </template>
                <template slot="payType">
                    <el-select 
                        v-model="billPayForm.payType"
                        @change="payTypeChange"
                    >
                        <el-option
                            v-for="item in payTypeList"
                            :key="item"
                            :value="item.dictKey"
                            :label="item.dictValue"
                        >
                        </el-option>
                    </el-select>
                </template>

                <template slot="payScene">
                    <el-select 
                        v-model="billPayForm.payScene"
                        @change="paySceneChange"
                    >
                        <el-option
                            v-for="item in paySceneList"
                            :key="item"
                            :value="item.dictKey"
                            :label="item.dictValue"
                        >
                        </el-option>
                    </el-select>
                </template>


            </avue-form>
            <div style="padding:1rem;overflow:hidden;">
                <div style="float:right;">
                    <el-button @click="confirmPayAction" type="primary">确认收款</el-button>
                    <el-button @click="cancelPay" type="normal">取消</el-button>
                </div>
            </div>
        </el-dialog>
        <div style="margin:1rem 0;">
                <el-button type="primary" @click="billPay">
                    账单收费
                </el-button>
                <el-button type="primary" @click="createBill">
                    生成账单
                </el-button>
        </div>
        <div>
                <span>收费科目: </span>
                <el-select 
                    multiple
                    :disabled="subjectDisabledFlag"
                    v-model="subjectIds"
                    @change="subjectIdChange"
                >
                    <el-option
                        v-for="item in subjectList"
                        :key="item"
                        :value="item.id"
                        :label="item.subjectName"
                    >
                    </el-option>
                </el-select>
                
                <!-- <avue-input-tree 
                    :disabled="subjectDisabledFlag"
                    node-key="id"
                    :props="defaultPropsSubjectId"
                    default-expand-all 
                    v-model="subjectIds"
                    placeholder="请选择收费科目" 
                    type="select" 
                    @change="subjectIdChange"
                    :dic="subjectList"
                >
                </avue-input-tree> -->
        </div>
        <el-table
        @selection-change="selectionChange"
        :data="tableData"
        style="width: 100%">
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                prop="ownerName"
                label="收费对象"
                width="180">
            </el-table-column>
            <el-table-column
                prop="billcycleNo"
                label="收费周期"
                width="180">
            </el-table-column>
            <el-table-column
                prop="subjectName"
                label="收费科目"
                width="180">
            </el-table-column>
            <el-table-column
                prop="standardName"
                label="收费标准"
                width="180">
            </el-table-column>
            <el-table-column
                prop="price"
                label="单价"
                width="180"> 
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ handleShowPrice(scope.row) }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column
                prop="count"
                label="数量"
                width="180">
            </el-table-column> -->
            <el-table-column
                prop="billStartDate"
                label="开始日期"
                width="180">
            </el-table-column>
            <el-table-column
                prop="billEndDate"
                label="结束日期"
                width="180">
            </el-table-column>
            <el-table-column
                prop="billAmount"
                label="未缴金额"
                width="180">
            </el-table-column>
            <el-table-column
                prop="billAmount"
                label="应收金额"
                width="180">
            </el-table-column>
            <el-table-column
                prop="lockFlag"
                label="状态"
                width="180">
                <template slot-scope="scope">
                    <div>
                        {{parseInt(scope.row.lockFlag)==1?'划扣锁定':'正常'}}
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageOption.current"
                :page-sizes="[10, 20, 30]"
                :page-size="pageOption.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOption.total"
            >
            </el-pagination>
        </div>
            <el-dialog
                :title="payScene==6?'查询中':'收款码'"
                :visible.sync="payInfo2.showQrCode"
                :close-on-click-modal="false"
                width="30%"
                top="16vh"
                append-to-body
                @close="closeQrCode"
            >
                <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
                    {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
                </div>
                <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
                    扫码支付后请勿手动关闭弹窗
                </div>
                <div style="text-align: center">
                    <div id="qrcodeNew" ref="qrcode" style="display: inline-block"></div>
                    <div>倒计时：{{ payInfo2.countdown }}</div>
                </div>
            </el-dialog>
            <!-- <printPreview ref="printPreview"></printPreview> -->

            
        <el-dialog title="生成账单" append-to-body :visible.sync="billGenerateFormFlag">
          <avue-form
            ref="billGenerateForm"
            v-if="billGenerateFormFlag"
            :option="billGenerateFormOption"
            v-model="billGenerateForm"
          >
              <template slot="subjectId">
                <el-select 
                    v-model="billGenerateForm.subjectId"
                    @change="billGenerateSubjectIdChange"
                >
                    <el-option
                        v-for="item in subjectList_"
                        :key="item"
                        :value="item.id"
                        :label="item.subjectName"
                    >
                    </el-option>
                </el-select>
              </template>
              
              <template slot="cycle">
                <el-input v-model="billGenerateForm.cycle" @input="cycleInput" @blur="cycleBlur" maxlength="3"></el-input>
              </template>
              
          </avue-form>
          <div style="text-align:center;">
            <el-button type="primary" @click="submitBillCreate">
              生成账单
            </el-button>
            <el-button @click="cancelBillCreate">
              取消
            </el-button>
          </div>

        </el-dialog>
        <printPreview ref="printPreview"></printPreview>
    </div>
</template>
  <script>
import QRCode from 'qrcodejs2';
  import {
        getSubjectList,
        getBindSubjectByTargetId,
        getStandardByTargetId,
        loadPayablePage,
        getPayTypeList,
        getPaySceneList,
        saveQrCodePay,
        loadPayStatusChannel,
        loadPayStatusPlatform,
        getCouponList,
        getDict,
        getGenerateEnddateNew,
        generateFeeBillNew,
        calculatePreferent
    } from '@/api/charge/charge-pay';
    import {
        loadZhxx
    } from '@/api/charge';
    import {mapGetters, mapState} from "vuex";
    import printPreview from '@/views/v4ward/pay/printdialog-v2/printPreview';
    export default {
        components: { printPreview },
        props: ['targetId'],
        data() {
        return {
            divideBillGroupList:[],
            totalDerateAmount:0,
            pageOption:{
                total:0,
                size:10,
                current:1,
            },
            dicts:[],
            defaultPropsSubjectId:{
                children: 'children',
                label: 'name'
            },
            payScene:'',
            payManName:'',
            totalCalAmount:'',
            communityName:'',
            payInfo:{
                payBillNo:''
            },
            payInfo2:{
                timer:'',
                showQrCode:false,
                countdown:'',
                tradeStatus:'',
            },
            subjectDisabledFlag:true,
            showAuthCodeFlag:false,
            payBillList:[],
            payTypeList:[],
            paySceneList:[],
            subjectList:[],
            subjectList_:[],
            subjectIds:'',
            billPayForm:{},
            billPayBoxFlag:false,
            billPayData:[{
                date: '物业费',
                couponName: '交满1000元送大米一袋',
                address: '202010',
                shouldpay:'180',
                discount:'30'
            }],
            tableData:[],
            billGenerateFormFlag:false,
            showBillPayTableFlag:false,
            billGenerateForm:{},
            tempSubjectList:[],
            // tableData: [{
            //     date: '吴丽',
            //     name: '2020/07',
            //     address: '物业费',
            //     standard: '高层物业费',
            //     price: '1.5元/㎡/月',
            //     count: '100',
            //     startdate: '2020/07/01',
            //     enddate: '2020/07/31',
            //     unpay: '180',
            //     shouldpay: '180',
            //     status: '正常'
            // }]
        }
      },
      
    computed: {
        ...mapGetters(["tagList"]),
        
       billGenerateFormOption(){
         return{
            menuBtn:false,
            column: [{
                        label: "客户",
                        prop: "client",
                        disabled:true,
                        // formslot:true,
                        span: 12
                    },{
                        label: "房间",
                        prop: "roomName",
                        disabled:true,
                        // formslot:true,
                        span: 12
                    },{
                        label: "收费科目",
                        prop: "subjectId",
                        // disabled:true,
                        formslot:true,
                        span: 12
                    },{
                        label: "收费标准",
                        prop: "standard",
                        disabled:true,
                        // formslot:true,
                        span: 12
                    },{
                        label: "数量",
                        prop: "floorage",
                        disabled:true,
                        // formslot:true,
                        span: 12
                    },{
                        label: "开始时间",
                        prop: "startTime",
                        type: "month",
                        format: 'yyyy-MM',
                        valueFormat: 'yyyy-MM-dd',
                        // disabled:true,
                        // formslot:true,
                        span: 12
                    },{
                        label: "期数",
                        prop: "cycle",
                        // disabled:true,
                        // maxlength:3,
                        formslot:true,
                        span: 12
                    },{
                        label: "结束时间",
                        prop: "endTime",
                        type: "month",
                        format: 'yyyy-MM',
                        disabled:true,
                        // formslot:true,
                        span: 12
                    },
                    ]
            }
        },
       billPayFormOption(){
         return{
            menuBtn:false,
            column: [{
                        label: "优惠券",
                        prop: "coupon",
                        formslot:true,
                        span: 12
                    },{
                        label: "收款方式",
                        prop: "payType",
                        formslot:true,
                        span: 12,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择收款方式",
                            trigger: "blur"
                        }],
                    },{
                        label: "收款类型",
                        prop: "payScene",
                        formslot:true,
                        span: 12,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择收款类型",
                            trigger: "blur"
                        }],
                    },{
                        label: "付款码",
                        prop: "authCode",
                        formslot:true,
                        display:false,
                        span: 12,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请输入付款码",
                            trigger: "blur"
                        }],
                    },{
                        label: "收款备注",
                        prop: "description",
                        span: 24,
                        type: "textarea",
                    },]
            }
        }
    },
      created(){
        this.loadDicts();
      },
      methods:{
          
          createBill(){
              console.log("createBill====");
              if(!this.targetId){
                this.$message.error('请选择房号!');
                return;
              }
              
            loadZhxx({roomId:this.targetId}).then(({ data }) => {
            this.zhxx = data[0];
            this.billGenerateFormFlag = true;
            this.billGenerateForm.subjectId = ''
            this.billGenerateForm.standard = ''
            this.billGenerateForm.startTime = ''
            this.billGenerateForm.cycle = ''
            this.billGenerateForm.endTime = ''
            this.billGenerateForm.floorage = this.zhxx.floorage;
            this.billGenerateForm.client = this.zhxx.householder;
            this.billGenerateForm.roomName = this.zhxx.roomName;
            });
            this.subjectList_ = this.subjectList.slice(1);
              // this.billGenerateFormFlag = true;
              // this.billGenerateForm.client = this.zhxx.householder;
              // this.billGenerateForm.roomName = this.communityName;
              // console.log(this.billGenerateForm);
          },
        cycleBlur(e){
            console.log("cycleBlur=====>",e);
            let val = e.target.value;
          if(!val){
              this.$message.error('请填写期数！');
              return;
          }
          if(!this.billGenerateForm.startTime){
              this.$message.error('请选择账单开始时间！');
              return;
          }
          console.log("this.billGenerateForm.standardId====>",this.billGenerateForm.standardId);
            getGenerateEnddateNew({
                startTime:this.billGenerateForm.startTime+' '+'00:00:00',
                periodNum:val,
                standardId:this.billGenerateForm.standardId,
                subjectId:this.billGenerateForm.subjectId,
                targetId:this.targetId
            }).then((res)=>{
                console.log(res);
                // this.billGenerateForm.endTime = res.data.split(' ')[0];
                this.billGenerateForm.endTime = res.data;

          });
        },
        cycleInput(val){
        //     if(!val){
        //         this.$message.error('请填写期数！');
        //         return;
        //     }
        //     if(!this.billGenerateForm.startTime){
        //         this.$message.error('请选择账单开始时间！');
        //         return;
        //     }
        // //   let billcycleNo = this.billGenerateForm.startTime.replace('-','');
        // //   let itemsetId = this.billGenerateForm.itemsetId;
        //   console.log("this.billGenerateForm.standardId====>",this.billGenerateForm.standardId);
        //     getGenerateEnddateNew({
        //         startTime:this.billGenerateForm.startTime+' '+'00:00:00',
        //         periodNum:val,
        //         standardId:this.billGenerateForm.standardId,
        //         subjectId:this.billGenerateForm.subjectId,
        //         targetId:this.targetId
        //     }).then((res)=>{
        //         console.log(res);
        //         // this.billGenerateForm.endTime = res.data.split(' ')[0];
        //         this.billGenerateForm.endTime = res.data;
        //   });
        },
        cancelBillCreate(){
          this.billGenerateFormFlag = false;
        },
        submitBillCreate(){
            if(!this.billGenerateForm.subjectId){
                this.$message.error('请选择收费科目！');
                return;
            }
            if(!this.billGenerateForm.startTime){
                this.$message.error('请选择账单开始时间！');
                return;
            }
            if(!this.billGenerateForm.cycle){
                this.$message.error('请填写账单期数！');
                return;
            }
            if(!this.billGenerateForm.endTime){
                this.$message.error('请选择账单结束时间！');
                return;
            }
          let self = this;
          console.log("this.billGenerateForm.standardId====>",this.billGenerateForm.standardId);
          generateFeeBillNew({
            startTime:this.billGenerateForm.startTime+' '+'00:00:00',
            ownerName:this.billGenerateForm.client,
            endTime:this.billGenerateForm.endTime,
            standardId:this.billGenerateForm.standardId,
            targetId:this.targetId
          }).then((res)=>{
            self.$message.success("操作成功!");
            self.billGenerateFormFlag = false;
            console.log(res);
            self.loadBillList(self.targetId);
          });
        },
    //查询预收费金额
       billGenerateSubjectIdChange(val){
         console.log("billGenerateSubjectIdChange=========>",val);
        this.billGenerateForm.standardId = '';
        this.billGenerateForm.standard = '';
        this.billGenerateForm.itemsetId = '';
         getStandardByTargetId({cycleType:1,targetId:this.targetId,subjectId:val}).then((res)=>{
           
                console.log(res);
                this.tempSubjectList = res.data;
                console.log(this.tempSubjectList);
                setTimeout(()=>{
                  this.billGenerateForm.standardId = this.tempSubjectList[0].id;
                  this.billGenerateForm.standard = this.tempSubjectList[0].name;
                  this.billGenerateForm.itemsetId = this.tempSubjectList[0].id;
                //   this.tempPrice = this.tempSubjectList[0].feePrice;
                //   this.tempFeeObject = this.tempSubjectList[0];
                })
        //    this.billGenerateForm.standard = res.data.advanceFeeItemName
        //    this.billGenerateForm.standardId = res.data.itemsetId

        //    this.billGenerateForm.itemsetId = res.data.itemsetId;

         });
       },
        // //打印预览
        // printprev() {
        //     if (
        //         this.payInfo.payBillNo != ''
        //         // &&(this.payInfo2.tradeStatus === 2 || this.payInfo.payType === 1)
        //     ) {
        //         this.$refs.printPreview.openPayChargePrintPreDialog(this.payInfo.payBillNo);
        //     } else {
        //         this.$message.warning('请先完成收款');
        //     }
        // },
        openTag(item) {
            let tag;
            if (item.name) {
            tag = this.findTag(item.name).tag;
            } else {
            tag = item;
            }
        if (tag.query.src === undefined || tag.query.src === 'undefined') {
            tag.query = {};
        }
            this.$router.push({
            path: this.$router.$avueRouter.getPath({
                name: tag.label,
                src: tag.value
            }, tag.meta),
            query: tag.query
            });
        },
        findTag(value) {
            let tag, key;
            this.tagList.map((item, index) => {
            if (item.value === value) {
                tag = item;
                key = index;
            }
            });
            return {tag: tag, key: key};
        },
          blurHandler(){
              console.log();
              this.$refs.authCodeInput;
              this.billPayForm.authCode
            //   this.billPayForm = Object.assign({},this.billPayForm,{authCode:''});
          },
          focusHandler(){
              console.log();
              this.$refs.authCodeInput;
              this.billPayForm.authCode
              this.billPayForm = Object.assign({},this.billPayForm,{authCode:''});
          },
          inputHandler(val){
              this.$refs.authCodeInput;
              this.billPayForm.authCode
            //   this.billPayForm = Object.assign({},this.billPayForm,{authCode:''});
          },
          couponNameChange(scope,id){
              if(!id){
                  this.billPayData[scope.$index].discount = '';


                    let billPayList = this.deepClone(this.billPayData);
                    
                        let totalCount = 0;
                        let totalDerate = 0;
                        billPayList.forEach((ele,index)=>{
                            console.log(ele);
                            console.log(parseFloat(ele.billAmount) - parseFloat(ele.discount))
                            totalCount = parseFloat(totalCount) + (parseFloat(ele.billAmount) - parseFloat(ele.discount?ele.discount:0));
                            totalDerate = parseFloat(totalDerate) + parseFloat(ele.discount?ele.discount:0)
                        });
                        console.log(totalCount);
                        this.totalCalAmount = totalCount.toFixed(2);
                        this.totalDerateAmount = totalDerate.toFixed(2);


                  return;
              }
              console.log(this.billPayData,scope);
              let ele_ = this.billPayData[scope.$index];
              calculatePreferent({
                preferentId:ele_.couponId,
                cycleNos:ele_.billcycleNo,
                shouldAmount:ele_.billAmount,
                billList:this.divideBillGroupList[scope.$index]
              }).then((res)=>{
                    this.billPayTableFlag = false;
                    console.log(res);
                    this.billPayData[scope.$index].discount = res.data;
                    let billPayList = this.deepClone(this.billPayData);
                    this.billPayData = [];
                    console.log(this.billPayData);
                    scope.row.discount = res.data;
                    // this.$set(this.$refs.billPayTable.$data.tableData,index,row);
                    console.log("this.$refs.billPayTable====>",this.$refs.billPayTable);
                    setTimeout(()=>{
                        this.billPayTableFlag = true;
                        // this.$refs.billPayTable.data[scope.$index].discount = res.data;
                        // this.$set(this.billPayData[scope.$index], 'discount', res.data)
                        // this.billPayData[scope.$index] = Object.assign({},this.billPayData[scope.$index],{discount: res.data})
                        // this.$set(this.$refs.billPayTable.data[scope.$index], 'discount', res.data)
                        this.billPayData = billPayList;
                        let totalCount = 0;
                        let totalDerate = 0;
                        billPayList.forEach((ele,index)=>{
                            console.log(ele);
                            console.log(parseFloat(ele.billAmount) - parseFloat(ele.discount))
                            totalCount = parseFloat(totalCount) + (parseFloat(ele.billAmount) - parseFloat(ele.discount?ele.discount:0));
                            totalDerate = parseFloat(totalDerate) + parseFloat(ele.discount?ele.discount:0)
                        });
                        console.log(totalCount);
                        this.totalCalAmount = totalCount.toFixed(2);
                        this.totalDerateAmount = totalDerate.toFixed(2);
                        console.log("this.billPayData======>",this.billPayData);
                    });
              });
          },
            findDictValue(dictKey, dictData) {
            let res;
            if (!dictKey || !dictData || dictData.length == 0) {
                console.log('emoty==>');
                return '';
            }
            dictData.forEach((item) => {
                if (item.dictKey == dictKey) {
                res = item;
                }
            });
            return res.dictValue || "";
            },
            loadDicts() {
                //圆整方式,计费方式,定价模式,支付周期,周期单位,账单生成颗粒,违约金起算日期(应收日期),收费精度,算费费率单位,不足月计算方式,不足月天数定义,收费仪表大类,收费仪表小类
                const dictCodes = [
                    'fee_standard_round_way',
                    'fee_standard_cal_way',
                    'fee_standard_pricing_model',
                    'fee_standard_cycle_start_rule',
                    'fee_standard_cycle_type',
                    'fee_standard_cycle_unit',
                    'fee_standard_bill_generate_rule',
                    'fee_standard_delay_start_type',
                    'fee_standard_precision',
                    'fee_standard_unit',
                    'fee_standard_less_month_way',
                    'fee_standard_less_month_days_way',
                    'fee_standard_meter_big',
                    'fee_standard_meter_big_small',
                ];
                let promises = [];
                dictCodes.forEach((item) => {
                    promises.push(getDict({ code: item }));
                });
                Promise.all(promises).then((resArr) => {
                    let dicts = {};
                    resArr.forEach((item, index) => {
                    let key = dictCodes[index];
                    dicts[key] = item.data;
                    });
                    this.dicts = dicts;
                    // this.disableAddBtn = false;
                    console.log('this.dicts==>', this.dicts);
                });
            },
            handleShowPrice(item) {
                try {
                    let res = '';
                    if (item.feeWay == '1') {
                    res +=
                        item.feePrice +
                        '元 / m² .' +
                        this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
                    } else if (item.feeWay == '2') {
                    // res +=
                    //   item.feePrice + '元 .' + this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
                    } else if (item.feeWay == '3') {
                    if (item.pricingModel == '1') {
                        res +=
                        item.feePrice +
                        '元 / ' +
                        this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
                    } else {
                        res = '';
                    }
                    } else if (item.feeWay == '99') {
                    if (item.pricingModel == '1') {
                        res +=
                        item.feePrice +
                        '元 / ' +
                        this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
                    } else {
                        res = '';
                    }
                    }
                    return res;
                } catch (err) {
                    console.log('handleShowPrice err==>', err);
                    return '';
                }
            },
            // 获取收费科目
            getSubjectListHandler(targetId){
                getBindSubjectByTargetId({targetId:targetId}).then((res)=>{
                    console.log(res);
                    this.subjectList = res.data;
                    this.subjectList.unshift({id:'',subjectName:'全部'});
                    console.log(this.subjectList);
                    this.subjectIds = [this.subjectList[0].id];
                })
            },
            subjectDisabled(){
                this.subjectDisabledFlag = true;
                this.subjectList = [];
                this.tableData = [];
            },
            subjectActive(){
                this.subjectDisabledFlag = false;
            },
            confirmPayAction(){
                this.genearateQrCode()
            },
            resetRepeatArray(arr_){
                var obj = {};
                let arr = this.deepClone(arr_);
                arr = arr.reduce(function(item, next) {
                    obj[next.subjectId] ? '' : obj[next.subjectId] = true && item.push(next);
                    return item;
                }, []);
                console.log("resetRepeatArray=====>",arr,this.payBillList);
                return arr;
            },
            getCollectBillList(){
                let self = this;
                this.showBillPayTableFlag = false;
                let divideGroupList = [];
                let tempArr = [];
                let targetId = this.targetId;
                let arr = this.resetRepeatArray(this.payBillList);
                console.log(arr);
                arr.forEach((ele_,index_)=>{
                    let billCycleNoArr = [];
                    let shouldPayAmount = 0.00;
                    let tempDivideGroupList = [];
                    this.payBillList.forEach((ele,index)=>{
                        if( ele_.subjectId === ele.subjectId ){
                            tempDivideGroupList.push(ele);
                            billCycleNoArr.push(ele.billcycleNo);
                            shouldPayAmount = parseFloat(shouldPayAmount)+parseFloat(ele.billAmount);
                        }
                    });
                    divideGroupList.push(tempDivideGroupList);
                    if(billCycleNoArr.length>0){
                        tempArr.push({
                            subjectName:ele_.subjectName,
                            billAmount:Math.round(shouldPayAmount*100)/100,
                            billcycleNo:billCycleNoArr.join(','),
                            subjectId:ele_.subjectId
                        });
                    }
                });
                console.log("divideGroupList======>",divideGroupList);
                this.divideBillGroupList = divideGroupList;
                  tempArr.forEach((ele,index)=>{
                      (function(ele,targetId){
                        getCouponList({subjectId:ele.subjectId,targetId:targetId,resourceType:1,shouldAmount:ele.billAmount,cycleNos:ele.billcycleNo}).then((res)=>{
                            console.log("getCouponList===>",res);
                            // ele.couponName = res.data.name;
                            ele.couponName = res.data;
                            ele.couponId = '';
                            if(index === (tempArr.length-1)){
                                setTimeout(()=>{
                                    self.showBillPayTableFlag = true;
                                })
                            }
                        });
                      })(ele,targetId);
                  });
                console.log("getCollectBillList==========tempArr=====>",tempArr);
                this.billPayData = tempArr;
                console.log("getCollectBillList==========tempArr=====>",this.billPayData);
                
            },
            getBillFormData(){
                let self = this;
                    console.log(this.payBillList);
                        this.payScene = this.billPayForm.payScene
                        let payScene = this.payScene;
                        let payType = this.billPayForm.payType
                        let authCode = this.billPayForm.authCode
                        let totalDerateAmount = this.totalDerateAmount;
                        let totalCouponAmount = 0;
                        let totalShouldAmount = this.totalCalAmount;

                        let payList = [];
                        let communityId = '';
                        let targetId = '';
                        let totalCalAmount = 0;
                        let payManName = '';
                        this.payBillList.forEach((ele,index)=>{
                            communityId = ele.communityId;
                            targetId = ele.targetId;
                            payManName = ele.ownerName;
                            totalCalAmount = parseFloat(totalCalAmount)+parseFloat(ele.billAmount);
                            self.billPayData.forEach((ele_,index)=>{
                                console.log(ele_);
                                if(ele_.subjectId === ele.subjectId){
                                    payList.push({
                                        subjectId:ele.subjectId,
                                        standardId:ele.standardId,
                                        linkId:ele.id,
                                        calAmount:ele.billAmount,
                                        shouldAmount:ele.billAmount,
                                        isDiscount:0,
                                        billcycleNo:ele.billcycleNo,
                                        description:'description',
                                    });
                                }
                                // else{
                                //     payList.push({
                                //         subjectId:ele.subjectId,
                                //         standardId:ele.standardId,
                                //         linkId:ele.id,
                                //         calAmount:ele.billAmount,
                                //         shouldAmount:ele.billAmount,
                                //         isDiscount:0,
                                //         billcycleNo:ele.billcycleNo,
                                //         description:'description',
                                //     });
                                // }
                            });
                        })

                        totalCalAmount = Math.round(totalCalAmount*100)/100;
                        this.billPayData.forEach((ele_,index)=>{
                            if( ele_.couponId && parseFloat(ele_.discount)>0 ){
                                payList.push({
                                    subjectId:ele_.subjectId,
                                    linkId:ele_.couponId,
                                    isDiscount:1,
                                    calAmount:ele_.discount,
                                    shouldAmount:ele_.discount,
                                });
                            }
                        });
                        this.payParams = {
                                            authCode: authCode,
                                            communityId: communityId,
                                            payScene: payScene,
                                            payType: payType,
                                            totalDerateAmount: totalDerateAmount,
                                            totalCalAmount: totalCalAmount,
                                            totalShouldAmount: totalShouldAmount,
                                            totalCouponAmount: totalCouponAmount,
                                            totalAccountpayAmount: 0,
                                            totalDelayAmount: 0,
                                            payManName: payManName,
                                            targetId: targetId,
                                            resourceType: 1,
                                            payCost: 1,
                                            payList: payList
                                        }
                                        console.log(this.payParams);
            },
            //生成二维码
            genearateQrCode() {
                this.$refs.billPayForm.validate((valid) => {
                    if (valid) {
                        this.getBillFormData();
                        console.log(this.payParams);
                        if(parseInt(this.payScene)==5){
                            this.qrCodePay();
                        }else if(parseInt(this.payScene)==6){
                            this.authCodePay();
                        }else{
                            this.normalPay();
                        }
                    }
                });
            },
            //打印预览
            printprev(){
                this.$confirm('收费成功，是否需要打印收据？', '提示', {
                        confirmButtonText: '打印',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                    if (
                            this.payInfo.payBillNo != ''
                            // &&(this.payInfo2.tradeStatus === 2 || this.payInfo.payType === 1)
                        ) {
                            this.billPayBoxFlag = false;
                            this.resetAllData();
                            this.$refs.printPreview.openPayChargePrintPreDialog(this.payInfo.payBillNo);
                        } else {
                            this.$message.warning('请先完成收款');
                        }
                        
                    }).catch(() => {
                        // this.$message({
                        //     type: 'info',
                        //     message: '已取消删除'
                        // });
                        //重置数据
                        this.resetAllData();
                    });
            
            },
            qrCodePay(){
                
                        saveQrCodePay(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
                            ({ data }) => {
                            this.payInfo2.showQrCode = true;
                            this.payInfo.payBillNo = data.payNo;
                            this.$nextTick(() => {
                                new QRCode('qrcodeNew', {
                                width: 250,
                                height: 250,
                                text: data.qrCodeUrl,
                                });
                            });
                            this.payInfo2.showQrCode = true;
                            this.payInfo2.countdown = 120;
                            this.payInfo2.timer = setInterval(() => {
                                if (this.payInfo2.countdown === 0) {
                                    clearInterval(this.payInfo2.timer);
                                    this.payInfo2.showQrCode = false;
                                    this.$message.info('倒计时结束，二维码弹窗关闭');
                                    
                                    this.$confirm('收费失败，请手动确认缴费状态！', '提示', {
                                        confirmButtonText: '更新账单',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    }).then(() => {
                                        // this.$message({
                                        //     type: 'success',
                                        //     message: '删除成功!'
                                        // });
                                        // this.printprev()
                                        let {tag, key} = this.findTag('/v4ward/fundpay/fundpay-abnormal');
                                        this.$store.commit("DEL_TAG", tag);
                                        this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal`});
                                    }).catch(() => {
                                        // this.$message({
                                        //     type: 'info',
                                        //     message: '已取消删除'
                                        // });     
                                        //重置数据
                                        this.resetAllData();    
                                    });

                                    // this.resetAllData();
                                    // this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal?payNo=${data.payNo}&resourceType=1`});

                                }
                                if (this.payInfo2.countdown % 5 === 0) {
                                    loadPayStatusPlatform({ payNo: this.payInfo.payBillNo }).then(({ data }) => {
                                        this.payInfo2.tradeStatus = data.payStatus;
                                        if (parseInt(data.payStatus) == 1) {
                                            this.payInfo2.showQrCode = false;
                                            this.$message.success('支付成功');
                                            this.isSuccess = true;
                                            clearInterval(this.payInfo2.timer);

                                            // 可以打印
                                            this.printprev()
                                            // this.$confirm('收费成功，是否需要打印收据？', '提示', {
                                            //     confirmButtonText: '打印',
                                            //     cancelButtonText: '取消',
                                            //     type: 'warning'
                                            // }).then(() => {
                                            //     // this.$message({
                                            //     //     type: 'success',
                                            //     //     message: '删除成功!'
                                            //     // });
                                            //     this.printprev()
                                            //     this.resetAllData();   
                                            // }).catch(() => {
                                            //     // this.$message({
                                            //     //     type: 'info',
                                            //     //     message: '已取消删除'
                                            //     // });     
                                            //     //重置数据
                                            //     this.resetAllData();    
                                            // });
                                            // this.submitAllBill();
                                        }
                                    });
                                }
                                this.payInfo2.countdown--;
                            }, 1000);
                            }
                        );
            },
            // 扫码枪
            authCodePay(){
                
                        saveQrCodePay(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
                            ({ data }) => {
                            // this.payInfo2.showQrCode = true;
                            this.payInfo.payBillNo = data.payNo;
                            this.payInfo2.showQrCode = true;
                            this.payInfo2.countdown = 120;
                            this.payInfo2.timer = setInterval(() => {
                                if (this.payInfo2.countdown === 0) {
                                    clearInterval(this.payInfo2.timer);
                                    this.payInfo2.showQrCode = false;
                                    this.$message.info('倒计时结束，二维码弹窗关闭');
                                    // this.resetAllData();
                                    let {tag, key} = this.findTag('/v4ward/fundpay/fundpay-abnormal');
                                    this.$store.commit("DEL_TAG", tag);
                                    this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal`});
                                    // this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal?payNo=${data.payNo}&resourceType=1`});
                                }
                                if (this.payInfo2.countdown % 5 === 0) {
                                loadPayStatusChannel({ payNo: this.payInfo.payBillNo }).then(({ data }) => {
                                    this.payInfo2.tradeStatus = data.payStatus;
                                    if (parseInt(data.payStatus) == 1) {
                                    this.payInfo2.showQrCode = false;
                                    this.$message.success('支付成功');
                                    this.isSuccess = true;
                                    clearInterval(this.payInfo2.timer);
                                    // 可以打印
                                     this.printprev()

                                            // this.$confirm('收费成功，是否需要打印收据？', '提示', {
                                            //     confirmButtonText: '打印',
                                            //     cancelButtonText: '取消',
                                            //     type: 'warning'
                                            // }).then(() => {
                                            //     // this.$message({
                                            //     //     type: 'success',
                                            //     //     message: '删除成功!'
                                            //     // });
                                            //     this.printprev()
                                            //     this.resetAllData();   
                                            // }).catch(() => {
                                            //     // this.$message({
                                            //     //     type: 'info',
                                            //     //     message: '已取消删除'
                                            //     // });     
                                            //     //重置数据
                                            //     this.resetAllData();    
                                            // });
                                    //重置数据
                                    // this.resetAllData();
                                    // this.submitAllBill();
                                    }
                                });
                                }
                                this.payInfo2.countdown--;
                            }, 1000);
                            }
                        );
            },
            
            normalPay(){
                        saveQrCodePay(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
                            ({ data }) => {
                            this.payInfo.payBillNo = data.payNo;
                                loadPayStatusChannel({ payNo: this.payInfo.payBillNo }).then(({ data }) => {
                                    this.payInfo2.tradeStatus = data.payStatus;
                                    if (parseInt(data.payStatus) == 1) {
                                    this.$message.success('支付成功');
                                    // 可以打印
                                    this.printprev()

                                            // this.$confirm('收费成功，是否需要打印收据？', '提示', {
                                            //     confirmButtonText: '打印',
                                            //     cancelButtonText: '取消',
                                            //     type: 'warning'
                                            // }).then(() => {
                                            //     // this.$message({
                                            //     //     type: 'success',
                                            //     //     message: '删除成功!'
                                            //     // });
                                            //     this.printprev()
                                            //     this.resetAllData();   
                                            // }).catch(() => {
                                            //     // this.$message({
                                            //     //     type: 'info',
                                            //     //     message: '已取消删除'
                                            //     // });     
                                            //     //重置数据
                                            //     this.resetAllData();    
                                            // });
                                    //重置数据
                                    // this.resetAllData();
                                    // this.submitAllBill();
                                    }
                                });
                            }
                        );
            },
            //关闭二维码
            closeQrCode() {
            setTimeout(() => {
                this.$refs.qrcode.innerHTML = '';
            }, 300);
                clearInterval(this.payInfo2.timer);
            },
            resetAllData(){
                let self = this;
                // location.reload();
                this.billPayForm = {};
                this.tableData = [];
                this.billPayBoxFlag = false;
                self.loadBillList(self.targetId);
            },
            payTypeChange(val){
                if(val){
                    this.billPayForm.payScene = '';
                    if(parseInt(val)==1 || parseInt(val)==8){
                        this.$refs.billPayForm.columnOption[0].column[3].display=false;
                        this.showAuthCodeFlag = false;
                        this.$refs.billPayForm.columnOption[0].column[2].display=false;
                    }else{
                        this.showAuthCodeFlag = true;
                        this.$refs.billPayForm.columnOption[0].column[2].display=true;
                    }
                    getPaySceneList({payType:val}).then((res)=>{
                        this.paySceneList = res.data;
                        console.log(res);
                    });
                }
            },
          paySceneChange(val){
              console.log(this.$refs.billPayForm);
              if(parseInt(val)==6){
                  this.showAuthCodeFlag = true;
                  this.$refs.billPayForm.columnOption[0].column[3].display=true;
              }else{
                  this.showAuthCodeFlag = false;
                  this.$refs.billPayForm.columnOption[0].column[3].display=false;
              }
          },
        subjectIdChange(val){
            let self = this;
            if(val&&val.length>1){
                console.log("subjectIdChange=====>",val);
                val.forEach((ele,index)=>{
                    if(!ele){
                        self.subjectIds.splice(index,1);
                    }
                });
            }
            this.pageOption.current = 1;
            this.loadBillList(this.targetId,'',val);
            console.log(val);
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageOption.size = val;
            this.loadBillList(this.targetId,'',val);
        },
        handleCurrentChange(val) {
            this.pageOption.current = val;
            console.log(`当前页: ${val}`);
            this.loadBillList(this.targetId,'',val);
        },
          loadBillList(targetId,targetName,subjectIds){
              this.targetId = targetId;
              if(targetName){
                  this.communityName = targetName;
              }
              let subjectIds_ = [];
                if(subjectIds&&subjectIds.length>0){
                    subjectIds_ = subjectIds.join(',');
                }else{
                    subjectIds_ = this.subjectIds.join(',');
                }
                console.log("subjectIds_====>",subjectIds_);
              loadPayablePage({targetId: this.targetId,subjectIds:subjectIds_,size:this.pageOption.size,current:this.pageOption.current}).then(({data})=>{
                  console.log(data);
                  this.pageOption.total = data.total;
                  this.tableData = data.records;
                //   this.tableData.forEach((ele,index)=>{
                //       (function(ele,targetId){
                //         getCouponList({subjectId:ele.subjectId,targetId:targetId,resourceType:1}).then((res)=>{
                //             console.log("getCouponList===>",res);
                //             // ele.couponName = res.data.name;
                //             ele.couponName = res.data;
                //         });
                //       })(ele,targetId);
                //   });
                  console.log("loadPayablePage=========>",this.tableData);
                //   this.communityName = data.records[0].communityName;
                  this.getBillFormData();
                  console.log(this.payParams);
                  this.payManName = data.records[0].ownerName;
              });
          },
          cancelPay(){
              this.billPayBoxFlag = false;
          },
          openBillPayBox(){
              this.billPayBoxFlag = true;
          },
          billPay(){
              if(this.payBillList.length==0){
                  this.$message.error('请先选择账单!');
                  return;
              }
              
              this.billPayForm = {};
              this.paySceneList = [];
              this.billPayData = this.payBillList;
              getPayTypeList().then((res)=>{
                  console.log(res);
                  this.payTypeList = res.data;
              });
                console.log(this.targetId);
                this.openBillPayBox();
                this.getBillFormData();
                this.getCollectBillList();
                  this.totalCalAmount = this.payParams.totalCalAmount;
                console.log("billPay====");
          },
          selectionChange(selection){
              console.log(selection);
              this.payBillList = selection;
          },
      },
    }
  </script>
<style>
</style>